import ResetPage from './ResetPage'

export default ResetPage
// eslint-disable-next-line import/export
export * from './ResetPage'
